const consts = {
    CDN_PREFIX: "."
}

export default consts